<template>
  <v-container class="py-0" fluid>
    <v-row align="center">
      <v-col class="py-1 px-0">
        <div class="choice-material__actions">
          <v-btn x-small outlined color="secondary" @click="selectAll">全て選択</v-btn>
          <v-btn x-small outlined color="secondary" class="ml-2" @click="deselectAll">全て解除</v-btn>
        </div>
        <v-checkbox
          v-for="(material, index) in materials"
          :key="index"
          v-model="selectedMaterialIds"
          :label="material.name"
          :value="material.id"
          color="secondary"
          hide-details
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  computed: {
    selectedSubject() {
      return this.$store.state.top.selectedSubject
    },

    materials() {
      let materials = this.$store.state.master.allMaterials
        .filter(material => material.subject_id === this.selectedSubject.id)

      if (this.$store.getters['user/isShingaku']) {
        const shingakuMaterial = materials.find(material => material.name === '新研究')
        if (shingakuMaterial) {
          materials = [shingakuMaterial, ...materials.filter(m => m.id !== shingakuMaterial.id)]
        }
      } else {
        materials = materials.filter(material => material.name !== '新研究')
      }

      return materials
    },

    selectedMaterialIds: {
      get() {
        return this.$store.state.top.currentSubjectCondition.selectedMaterials.map(material => material.id)
      },
      set(values) {
        this.$store.commit(
          'changeCurrentSubjectCondition',
          { selectedMaterials: this.materials.filter(material => values.includes(material.id)) }
        )
      }
    },
  },
  methods: {
    selectAll() {
      this.selectedMaterialIds = this.materials.map(material => material.id)
    },
    deselectAll() {
      this.selectedMaterialIds = []
    },
  },
}
</script>

<style lang="stylus" scoped>
  .choice-material
    display flex
    height 106px

    &__checkbox
      margin-top: 22px;

    &__actions
      margin-bottom: 8px

  .v-label
    font-weight bold
</style>
